/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClickerEntry } from '../../models/clicker-entry';
import { RecordClickerEntryDto } from '../../models/record-clicker-entry-dto';

export interface ClickerSessionsControllerRecordEntry$Params {
  id: string;
      body: RecordClickerEntryDto
}

export function clickerSessionsControllerRecordEntry(http: HttpClient, rootUrl: string, params: ClickerSessionsControllerRecordEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<ClickerEntry>> {
  const rb = new RequestBuilder(rootUrl, clickerSessionsControllerRecordEntry.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClickerEntry>;
    })
  );
}

clickerSessionsControllerRecordEntry.PATH = '/clicker/sessions/{id}/entries';
